import { FC } from 'react'

import { Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Widget, WidgetFooter, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

export const WidgetSkeleton: FC<{ count: number }> = ({ count }) => (
  <Stack gap={16}>
    {Array.from({ length: count }).map((_, index) => (
      <Widget key={index}>
        <WidgetTitle>
          <Skeleton variant="content" />
        </WidgetTitle>
        <WidgetFooter>
          <Skeleton variant="badge" fullWidth />
        </WidgetFooter>
      </Widget>
    ))}
  </Stack>
)
